import React from 'react';

// COMPLIANCE (Google Play account-deletion requirement): the /delete-account URL declared in the
// stores' Data safety section must show a real, logged-out-accessible page explaining how to delete
// an account — a redirect to the homepage reads as "invalid resource" to Google's checker (same
// failure class as the flagged privacy-policy stub). Logged-in users keep the self-service flow.
const INK = '#1F2733';
const GREY = '#5B6472';
const RED = '#D32F2F';
const FONT = "'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif";

const DeleteAccountPublic = ({ mode }) => {
  const isDataRights = mode === 'data-rights';
  const title = isDataRights ? 'Your privacy & data rights' : 'Delete your BestHand account';
  return (
    <div style={{ fontFamily: FONT, color: INK, maxWidth: 760, margin: '0 auto', padding: '56px 20px 72px' }}>
      <h1 style={{ fontSize: 32, fontWeight: 800, margin: '0 0 10px' }}>{title}</h1>
      <p style={{ fontSize: 16, color: GREY, lineHeight: 1.7, margin: '0 0 26px' }}>
        {isDataRights
          ? 'You can access, correct, or delete the personal data linked to your BestHand account at any time. Here is how:'
          : 'You can delete your BestHand account and the personal data linked to it at any time. Here is how:'}
      </p>

      <div style={{ display: 'grid', gap: 14 }}>
        <div style={{ border: '1px solid #E6E8EC', borderRadius: 14, padding: '18px 20px' }}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>1. In the app</div>
          <div style={{ fontSize: 15, color: GREY, lineHeight: 1.6 }}>
            Open the BestHand app → Profile → Settings → {isDataRights ? 'Privacy & data' : 'Delete account'} and follow the steps.
          </div>
        </div>
        <div style={{ border: '1px solid #E6E8EC', borderRadius: 14, padding: '18px 20px' }}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>2. Online</div>
          <div style={{ fontSize: 15, color: GREY, lineHeight: 1.6 }}>
            <a href={isDataRights ? '/login?return=/data-rights' : '/login?return=/delete-account'} style={{ color: RED, fontWeight: 700, textDecoration: 'none' }}>Log in to your account</a>
            {' '}and you will land on the self-service {isDataRights ? 'data rights' : 'deletion'} page.
          </div>
        </div>
        <div style={{ border: '1px solid #E6E8EC', borderRadius: 14, padding: '18px 20px' }}>
          <div style={{ fontWeight: 800, marginBottom: 6 }}>3. By email</div>
          <div style={{ fontSize: 15, color: GREY, lineHeight: 1.6 }}>
            Email <a href="mailto:support@besthandapp.com" style={{ color: RED, fontWeight: 700, textDecoration: 'none' }}>support@besthandapp.com</a> from the
            email address on your account with the subject {isDataRights ? '“Data request”' : '“Delete my account”'} and we will process your request.
          </div>
        </div>
      </div>

      <p style={{ fontSize: 13, color: GREY, lineHeight: 1.7, marginTop: 26 }}>
        What is deleted and what may be retained (e.g., transaction records we must keep by law) is described in our{' '}
        <a href="/privacy-policy" style={{ color: RED, textDecoration: 'none', fontWeight: 700 }}>Privacy Policy</a>.
      </p>
    </div>
  );
};

export default DeleteAccountPublic;
